import type React from 'react';

import { type OidcUserInfo, useOidcUser } from '@axa-fr/react-oidc';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

export const UserScopes: React.FC = () => {
  const { oidcUser } = useOidcUser();

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell width={4}>Key</TableCell>
          <TableCell>Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(Object.keys(oidcUser) as Array<keyof OidcUserInfo>).map((key) => (
          <TableRow key={key}>
            <TableCell>{key}</TableCell>
            <TableCell
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word'
              }}
            >
              {JSON.stringify(oidcUser[key])}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
